import styled from "styled-components";

const Style = styled.div`
  position: absolute;
  bottom: 20px;
  right: 340px;
  z-index: 500;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
  transition: .2s right;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

  &.collapsed {
    right: 16px;
  }

  button {
    background: white;
    border: 0px;
    border-bottom: 1px solid #CECECE;
    display: flex;
    flex-direction: column;
    padding: 12px 10px;
    outline: none;

    &.up {
      border-bottom: 0px;
      padding-bottom: 4px;
    }

    &.down {
      border-bottom: 0px;
      padding-top: 4px;
      color: #B4B4B4;
    }
  }
`;

export default Style;
